/*!
 * @splidejs/splide-extension-auto-scroll
 * Version  : 0.4.1
 * License  : MIT
 * Copyright: 2022 Naotoshi Fujita
 */ (function (b) {
  typeof define == "function" && define.amd ? define(b) : b();
})(function () {
  "use strict";
  function b(n) {
    n.length = 0;
  }
  function T(n, t, r) {
    return Array.prototype.slice.call(n, t, r);
  }
  function _(n) {
    return n.bind.apply(n, [null].concat(T(arguments, 1)));
  }
  function $(n) {
    return requestAnimationFrame(n);
  }
  function D(n, t) {
    return typeof t === n;
  }
  var N = Array.isArray;
  _(D, "function"), _(D, "string"), _(D, "undefined");
  function C(n) {
    return N(n) ? n : [n];
  }
  function F(n, t) {
    C(n).forEach(t);
  }
  var nn = Object.keys;
  function tn(n, t, r) {
    if (n) {
      var e = nn(n);
      e = r ? e.reverse() : e;
      for (var a = 0; a < e.length; a++) {
        var s = e[a];
        if (s !== "__proto__" && t(n[s], s) === !1) break;
      }
    }
    return n;
  }
  function en(n) {
    return (
      T(arguments, 1).forEach(function (t) {
        tn(t, function (r, e) {
          n[e] = t[e];
        });
      }),
      n
    );
  }
  var rn = Math.min;
  function un() {
    var n = [];
    function t(u, d, i, c) {
      a(u, d, function (f, m, v) {
        var w = "addEventListener" in f,
          E = w
            ? f.removeEventListener.bind(f, m, i, c)
            : f.removeListener.bind(f, i);
        w ? f.addEventListener(m, i, c) : f.addListener(i),
          n.push([f, m, v, i, E]);
      });
    }
    function r(u, d, i) {
      a(u, d, function (c, f, m) {
        n = n.filter(function (v) {
          return v[0] === c && v[1] === f && v[2] === m && (!i || v[3] === i)
            ? (v[4](), !1)
            : !0;
        });
      });
    }
    function e(u, d, i) {
      var c,
        f = !0;
      return (
        typeof CustomEvent == "function"
          ? (c = new CustomEvent(d, { bubbles: f, detail: i }))
          : ((c = document.createEvent("CustomEvent")),
            c.initCustomEvent(d, f, !1, i)),
        u.dispatchEvent(c),
        c
      );
    }
    function a(u, d, i) {
      F(u, function (c) {
        c &&
          F(d, function (f) {
            f.split(" ").forEach(function (m) {
              var v = m.split(".");
              i(c, v[0], v[1]);
            });
          });
      });
    }
    function s() {
      n.forEach(function (u) {
        u[4]();
      }),
        b(n);
    }
    return { bind: t, unbind: r, dispatch: e, destroy: s };
  }
  var R = "move",
    q = "moved",
    on = "updated",
    H = "drag",
    K = "scroll",
    B = "scrolled",
    an = "destroy";
  function fn(n) {
    var t = n ? n.event.bus : document.createDocumentFragment(),
      r = un();
    function e(s, u) {
      r.bind(t, C(s).join(" "), function (d) {
        u.apply(u, N(d.detail) ? d.detail : []);
      });
    }
    function a(s) {
      r.dispatch(t, s, T(arguments, 1));
    }
    return (
      n && n.event.on(an, r.destroy),
      en(r, { bus: t, on: e, off: _(r.unbind, t), emit: a })
    );
  }
  function sn(n, t, r, e) {
    var a = Date.now,
      s,
      u = 0,
      d,
      i = !0,
      c = 0;
    function f() {
      if (!i) {
        if (
          ((u = n ? rn((a() - s) / n, 1) : 1),
          r && r(u),
          u >= 1 && (t(), (s = a()), e && ++c >= e))
        )
          return v();
        $(f);
      }
    }
    function m(g) {
      !g && E(), (s = a() - (g ? u * n : 0)), (i = !1), $(f);
    }
    function v() {
      i = !0;
    }
    function w() {
      (s = a()), (u = 0), r && r(u);
    }
    function E() {
      d && cancelAnimationFrame(d), (u = 0), (d = 0), (i = !0);
    }
    function I(g) {
      n = g;
    }
    function x() {
      return i;
    }
    return { start: m, rewind: w, pause: v, cancel: E, set: I, isPaused: x };
  }
  var cn = "slide";
  function G(n, t, r) {
    return Array.prototype.slice.call(n, t, r);
  }
  function P(n) {
    return n.bind.apply(n, [null].concat(G(arguments, 1)));
  }
  function O(n, t) {
    return typeof t === n;
  }
  function Y(n) {
    return !vn(n) && O("object", n);
  }
  P(O, "function"), P(O, "string");
  var dn = P(O, "undefined");
  function vn(n) {
    return n === null;
  }
  var ln = Object.keys;
  function mn(n, t, r) {
    if (n) {
      var e = ln(n);
      e = r ? e.reverse() : e;
      for (var a = 0; a < e.length; a++) {
        var s = e[a];
        if (s !== "__proto__" && t(n[s], s) === !1) break;
      }
    }
    return n;
  }
  function z(n) {
    return (
      G(arguments, 1).forEach(function (t) {
        mn(t, function (r, e) {
          n[e] = t[e];
        });
      }),
      n
    );
  }
  var J = Math.min,
    Q = Math.max,
    An = Math.floor,
    Tn = Math.ceil,
    Dn = Math.abs;
  function pn(n, t, r) {
    var e = J(t, r),
      a = Q(t, r);
    return J(Q(e, n), a);
  }
  var En = { speed: 1, autoStart: !0, pauseOnHover: !0, pauseOnFocus: !0 };
  function hn(n, t, r) {
    var e = fn(n),
      a = e.on,
      s = e.off,
      u = e.bind,
      d = e.unbind,
      i = t.Move,
      c = i.translate,
      f = i.getPosition,
      m = i.toIndex,
      v = i.getLimit,
      w = i.exceededLimit,
      E = t.Controller,
      I = E.setIndex,
      x = E.getIndex,
      g = t.Direction.orient,
      S = n.root,
      p = {},
      l,
      U,
      W,
      X,
      M,
      y;
    function wn() {
      var o = r.autoScroll;
      p = z({}, En, Y(o) ? o : {});
    }
    function Z() {
      !l && r.autoScroll !== !1 && ((l = sn(0, _n)), gn(), bn());
    }
    function j() {
      l &&
        (l.cancel(),
        (l = null),
        (y = void 0),
        s([R, H, K, q, B]),
        d(S, "mouseenter mouseleave focusin focusout"));
    }
    function gn() {
      p.pauseOnHover &&
        u(S, "mouseenter mouseleave", function (o) {
          (W = o.type === "mouseenter"), V();
        }),
        p.pauseOnFocus &&
          u(S, "focusin focusout", function (o) {
            (X = o.type === "focusin"), V();
          }),
        a(on, yn),
        a([R, H, K], function () {
          (M = !0), A(!1);
        }),
        a([q, B], function () {
          (M = !1), V();
        });
    }
    function yn() {
      var o = r.autoScroll;
      o !== !1 ? ((p = z(p, Y(o) ? o : {})), Z()) : j(), l && !dn(y) && c(y);
    }
    function bn() {
      p.autoStart &&
        (document.readyState === "complete" ? L() : u(window, "load", L));
    }
    function L() {
      l && l.isPaused() && l.start(!0);
    }
    function A(o) {
      o === void 0 && (o = !0), l && !l.isPaused() && l.pause(), (U = o);
    }
    function V() {
      U || (!W && !X && !M ? L() : A(!1));
    }
    function _n() {
      var o = f(),
        h = On(o);
      o !== h
        ? (c(h, x() !== 0 || !w(!0)), (y = f()), xn(y))
        : (A(!1), p.rewind && n.go(0));
    }
    function On(o) {
      var h = p.speed || 1;
      return (o += g(h)), n.is(cn) && (o = pn(o, v(!1), v(!0))), o;
    }
    function xn(o) {
      var h = n.length,
        k = (m(o) + h) % h;
      k !== x() && (I(k), t.Slides.update(), t.Pagination.update());
    }
    function Ln() {
      return !l || l.isPaused();
    }
    return { setup: wn, mount: Z, destroy: j, play: L, pause: A, isPaused: Ln };
  }
  typeof window < "u" &&
    ((window.splide = window.splide || {}),
    (window.splide.Extensions = window.splide.Extensions || {}),
    (window.splide.Extensions.AutoScroll = hn));
});
